import IAuthUserRepository from 'domain/interfaces/repositories/IAuthUserRepository'
import { LoginAuthUserCommandRequest } from 'domain/entities/authUser'

export const loginAuthUserCommand = (
  repository: IAuthUserRepository,
  data: LoginAuthUserCommandRequest,
) => {
  return repository.login(data)
}
